import React ,{useEffect}from 'react';
import './Book.css';

function Book() {
   //Google tag (gtag.js)
   useEffect(() => {
    // Ajouter la balise gtag.js si elle n'est pas déjà présente
    if (!document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=AW-11270497323"]`)) {
      const script = document.createElement("script");
      script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11270497323";
      script.async = true;
      document.head.appendChild(script);

      const inlineScript = document.createElement("script");
      inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-11270497323');
      `;
      document.head.appendChild(inlineScript);
    }


    // Ajouter un gestionnaire d'événements pour la soumission du formulaire
    const form = document.getElementById("reservation-form");
    if (form) {
      const handleSubmit = (e) => {
        e.preventDefault(); // Empêcher le rechargement de la page
        // Conversion : Demande de devis
        if (typeof window.gtag === "function") {
          window.gtag("event", "conversion", {
            send_to: "AW-11270497323/O-oKCLyDsdMZEKvImP4p", // ID de la conversion pour "Demande de devis"
          });
        }
        console.log("Événement de conversion pour demande de devis déclenché.");
        form.submit(); // Optionnel : soumission après l'événement
      };

      form.addEventListener("submit", handleSubmit);
        // Nettoyage du gestionnaire
        return () => {
          form.removeEventListener("submit", handleSubmit);
        };
      }
    }, []);
  return (
    <div className='Book'>
      <div className="ban">
        <div className="img-containr">
          <img src="/rees.jpg" alt="Instruments de ménage" className="ban-image" loading="lazy"/>
        </div>
        <div className="bann-content">
          <h1>RÉSERVATION <h5 class="banne-subtitle">Service nettoyage <span className='greater'>&gt;</span>Réservation</h5></h1>
        </div>
      </div>
    
      <div className="reservation-container">
      
        <div className="form-wrapper">
        <div className="titire">
  <h4>
    Obtenez un devis et réservez en <span class="highlight">60 secondes !</span> 
  </h4>
  <div class="subtitle">
    Remplissez le formulaire ci-dessous pour prendre rendez-vous !
  </div>
  <div class="underline"></div>
</div>

        <iframe 
          src="https://docs.google.com/forms/d/e/1FAIpQLSfwiUMveapYSEDmyNe937-OKbW6P1mueMgw0urSlw9dlmkj4w/viewform?embedded=true" 
          width="840" height="1001" 
          id="reservation-form" 
          frameborder="0" 
          marginheight="0" 
          marginwidth="0">
          Chargement…</iframe>
        
        
      </div>
      </div>
      
    </div>
  );
}

export default Book;